export const premiumData = [
    {
      'id': '1',
      'title': 'Full video course'
    },
    {
      'id': '2',
      'title': 'Live google video lessons'
    },
    {
      'id': '3',
      'title': 'Live trading lessons'
    },
    {
      'id': '4',
      'title': 'Personalized learning'
    },
    {
      'id': '5',
      'title': 'Live chat with other top forex traders in the chat room'
    },
    {
      'id': '6',
      'title': 'Access to members private group'
    },
    {
      'id': '7',
      'title': 'Two months VIP signals'
    },
    {
      'id': '8',
      'title': 'Team work schedule'
    },
    {
      'id': '9',
      'title': 'Support and accountability'
    },
    {
      'id': '10',
      'title': 'Access mentorship from any location'
    },
    {
      'id': '11',
      'title': 'Customized hoody'
    },
    {
      'id': '12',
      'title': 'Access to trading tools (ipad) & trade journal'
    },
  ]

export const vipData = [
    {
      'id': '1',
      'title': 'Professional guidance'
    },
    {
      'id': '2',
      'title': 'High regarded trader education'
    },
    {
      'id': '3',
      'title': 'Advanced risk management'
    },
    {
      'id': '4',
      'title': 'Precise stop and limit levels to maximize profit'
    },
    {
      'id': '5',
      'title': 'Copy trading and trading support'
    },
  ]
